import { render, staticRenderFns } from "./AdminKpiCards.vue?vue&type=template&id=4ed1cd98&scoped=true"
import script from "./AdminKpiCards.vue?vue&type=script&lang=js"
export * from "./AdminKpiCards.vue?vue&type=script&lang=js"
import style0 from "./AdminKpiCards.vue?vue&type=style&index=0&id=4ed1cd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1cd98",
  null
  
)

export default component.exports